import { get, post } from './utils';

export async function loginApi(params) {
  return post('/auth/user/login', params, {}, '');
}

export async function getCurrentUserApi() {
  return get('/users/me', {}, {}, '');
}

export async function forgotPasswordUserApi(params) {
  return post('/auth/user/forgot-password', params, {}, '');
}

export async function verifyResetCodeApi(params) {
  return post('/auth/user/verify-reset-code', params, {}, '');
}

export async function changePasswordApi(params) {
  return post('/auth/user/change-password', params, {}, '');
}
